import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

import VueScrollTo from 'vue-scrollto'

import './../node_modules/bulma/css/bulma.css';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendarAlt, faInfoCircle, faCheck, faInfo, faAngleRight, faAngleLeft,
    faEnvelope, faGlobe, faPhone, faLanguage } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
    faCalendarAlt,
    faInfoCircle,
    faCheck,
    faInfo,
    faAngleRight,
    faAngleLeft,

    faEnvelope,
    faGlobe,
    faPhone,
    faLanguage
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueScrollTo, {
  duration: 1600
})

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
    i18n
}).$mount('#app')
